import type { ProductLogoSmallProps } from '../types';

/**
 * 小サイズのSoftwareロゴアイコン
 */
export function ProductLogoSmallSoftware({
  size = 20,
  color = '#1874A1',
  ...props
}: ProductLogoSmallProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 22 21" fill="none" {...props}>
      <path d="M3.89453 2C3.34225 2 2.89453 2.44772 2.89453 3V11C2.89453 11.5523 3.34225 12 3.89453 12H4.39453C4.67067 12 4.89453 11.7761 4.89453 11.5V5C4.89453 4.44772 5.34225 4 5.89453 4H12.3945C12.6707 4 12.8945 3.77614 12.8945 3.5V3C12.8945 2.44772 12.4468 2 11.8945 2H3.89453Z" fill={color} />
      <path d="M6.89453 5C6.34225 5 5.89453 5.44772 5.89453 6V14C5.89453 14.5523 6.34225 15 6.89453 15H7.39453C7.67067 15 7.89453 14.7761 7.89453 14.5V8C7.89453 7.44772 8.34225 7 8.89453 7H15.3945C15.6707 7 15.8945 6.77614 15.8945 6.5V6C15.8945 5.44772 15.4468 5 14.8945 5H6.89453Z" fill={color} />
      <path d="M8.89453 9C8.89453 8.44772 9.34225 8 9.89453 8H17.8945C18.4468 8 18.8945 8.44772 18.8945 9V17C18.8945 17.5523 18.4468 18 17.8945 18H9.89453C9.34225 18 8.89453 17.5523 8.89453 17V9Z" fill={color} />
    </svg>;
}